import React from 'react';
import { globalStyles } from './globalStyles';

const GlobalStyle = () => {
  return <style>{globalStyles}</style>;
};

export default GlobalStyle;
